export const editData = {
  data() {
    return {
      // 限制只能输入今天之前日期
      dateOptions: {
        disabledDate: (date) => {
          return date && date.valueOf() > Date.now()
        },
      },
      regionsArr: [], // 区域数组
      protocolId: "", //对账单的id
      showMol: false, //是否显示影响因子字段
      pageName: "", //页面名称
      addtionSeleted: "",
      INDEX: "",
      tableLoading: false,
      tableLoading1: false,
      policyNameArr: [], // 投保人姓名列表
      insuredNameArr: [], // 被保险人姓名列表
      loading: false,
      hasAddition: true, // 是否有附加险
      insuranceInfoList: [], //投保资料列表
      insuranceContractList: [], // 保险合同列表
      customerNoticeList: [], //客户告知书列表
      otherInfoList: [], //其他资料列表
      uploadList: "insuranceContractList",
      themeList: ["保险合同", "投保资料", "客户告知书", "其他"],
      themeActive: 0,
      companyList: [], // 保司名称列表
      productListArr: [], // 产品名称列表
      salesmanList: [], // 出单机构业务员列表
      editFlag: "", // 新增还是编辑
      policyInfoList: {}, //保单详情列表
      additionalList: [], // 附加险列表
      fullAdditionalList: [],
      evTimeStamp: "",
      //基础信息
      formData: {
        offlineId: "", // 保单id
        companyName: "", // 保险公司
        companyCode:'',// 保司code
        companyId: "", // 保险公司
        productId: "", // 产品Id
        productCode: "", // 产品Code
        source:'',//产品来源
        insuranceCategory: "", //保险类别1：人身险；2：财险；3：车险
        productName: "", //产品名称
        fee: "", // 保费(元)
        policyNo: "", // 保单号
        payNumber: "1", // 期数；1首期；2续期
        insuredAmount: "", // 保额
        orgId: "", // 出单机构id
        orgName: "", // 出单机构名称
        salesmanId: "", // 业务员id
        salesmanName: "", // 业务员名称
        phoneNum: "", // 出单业务员手机号
        status: "", // 保单状态
        insureTime: "", // 承保日期
        reason: "", // 退保原因
        verifyTime: "", // 回访日期
        verifyStatus: "", // 回访状态
        effectTime: "", // 生效日期
        hesitateTime: "", // 过犹豫期日期
        payTime: "", // 投保日期
        returnTime: "", // 退保日期
        endTime: "", // 终止日期
        payType: "", // 交费方式
        payLimit: "", // 交费期限数字
        payment: "1", //交费期限单位
        guaranteeLimit: "", // 保障期限
        guaranteeType: "3", // 保障期限时间单位
        revokeDate: "", // 撤单日期
        refuseDate: "", // 拒保日期
        areaCode:[],// 区域
        includingDeath:'',// 是否含身故
        area:''
      },
      // 附加险
      disabledAdditional: [],
      formDynamic: {
        additional: [

        ],
      },
      //投保人
      policyHoderForm: {
        holderId: "", // 投保人Id
        holderName: "", // 投保人
        holderIdType: "", // 证件类型
        holderIdNo: "", // 投保人证件号
        holderSex: "", //投保人性别
        holderBirth: "", // 投保人出生日期
        holderIncome: "", // 年收入
        holderMobile: "", // 投保人电话
        holderEmail: "", // 投保人邮箱
        holderJob: "", // 职业
        holderAddress: "", // 投保人详细地址
        term: "", // 有效期
        lifelong: false, // 终身
      },
      // 被保险人
      insuredFormDynamic:{
        insuredForm: [{
          id: "", //被保险人id，
          infoType: '', //信息类型1投保人2被保险人
          name: "", // 被保险人姓名
          idType: "", // 被保险人证件类型1身份证2护照3军人证4其它5户口本6出生证
          idNo: "", // 被保险人证件号
          validPeriod:'',// 证件有效期
          sex: "", // 被保险人性别
          birth: "", // 被保险人出生日期
          holderRelation: "", // //与投保人的关系1本人2父母3子女4配偶
          income: "", // 被保险人年收入
          mobile: "", // 被保险人电话
          job: "", // 被保险人职业
          email: "", // 邮箱
          address: "", // 被保险人详细地址
          bank:'', //开户行
          cardNo:'',//卡号
          createTime: '',
          updateTime: '',
          createBy: '',
          updateBy: '',
          term: "", // 有效期
          lifelong: false, // 有效期-终身
          rights1:[
            {
              name:'',
              content:'',
              quota:'',
            }
          ], // 保障权益
          rights:''
        }]
      },
      //受益人
      beneficiaryType: "1", // 受益人类型
      benefitFormDynamic: {
        benefitForm: [
          {
            // benefitType:'2', // 受益人类型
            name: "", // 受益人姓名
            insuranceRelation: "", // 与被保险人关系
            idType: "", // 受益人证件类型
            idNo: "", //受益人证件号
            sex: "", //受益人性别
            birth: "", //受益人出生日期
            benefitScale: "", // 受益比例
            benefitOrder: "", // 收益顺序
          },
        ],
      },
      accountForm: {
        bank: "", //开户行
        account: "", //银行账户
      },
      formDataValidate: {
        companyCode: [
          { required: true, message: "请选择保险公司", trigger: "change" },
        ],
        productCode: [
          { required: true, message: "请选择保司产品", trigger: "change" },
        ],
        fee: [
          { required: true, message: "保费不能为空", trigger: "blur" },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ],
        policyNo: [
          { required: true, message: "保单号不能为空", trigger: "blur" },
        ],
        payTime: [
          { required: true,type: "date", message: "请选择投保日期", trigger: "change" },
        ],
        payNumber: [{ required: true }],
        orgName: [
          { required: true},
        ],
        salesmanId: [
          { required: true, message: "请选择业务员", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择保单状态", trigger: "change" },
        ],
        // insureTime: [
        //   {
        //     required: true,
        //     type: "date",
        //     message: "请选择承保日期",
        //     trigger: "change",
        //   },
        // ],
        reason:[{required: true,message:'退保原因不能为空',trigger:"blur"}],// 退保原因
        verifyStatus:[{required: true,message:'请选择回访状态',trigger:"change"}],// 退保原因
        insuredAmount: [
          {
            required: true,
            message: "保额不能为空",
            trigger: "blur",
          },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], //保额
        guaranteeLimit: [
          { required: true, message: "保障期限不能为空" },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], // 保障期限
        payLimit: [
          { required: true, message: "交费期限不能为空", trigger: "blur" },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], //交费期限
        payType: [
          { required: true, message: "请选择交费方式", trigger: "change" },
        ],
        effectTime: [
          {
            required: true,
            type: "date",
            message: "请选择生效日期",
            trigger: "change",
          },
        ],
        hesitateTime: [
          {
            required: true,
            type: "date",
            message: "请选择过犹豫期日期",
            trigger: "change",
          },
        ],
        areaCode: [
          {
            required: true,
            type:Array,
            message: "请选择区域",
            trigger: "change",
            validator(rule, value) {
              if (!value || !value.length) {
                return false;
              }
              return true;
            }
          },
        ],
      },
      // 附加险验证
      additionRules: {
        productId:[
          {
            required: true,
            message:'请选择产品',
            trigger:'change'
          }
        ],
        fee: [
          {required: true,message: "保费不能为空", trigger: "blur"},
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], //保费
        status:[
          {
            required:true,
            message:'请选择保单状态',
            trigger:'change'
          }
        ],
        payType: [
          { required: true, message: "请选择交费方式", trigger: "change" },
        ], //交费方式
        payLimit: [
          { required: true, message: "交费期限不能为空", trigger: "blur" },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], //交费期限
        guaranteeLimit: [
          { required: true, message: "保障期限不能为空", trigger: "blur" },
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], //保障期限
        insuredAmount: [
          {
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              return Number(value);
            },
          },
        ], //保额
      },
      // 投保人信息
      policyHoderValidate: {
        holderName: [{ required: true, message: "投保人姓名不能为空" }],
        holderIdType: [
          {
            required: true,
            message: "请选择投保人证件类型",
            trigger: "change",
          },
        ],
        holderIdNo: [{ required: true, message: "投保人证件号不能为空" }],
        holderMobile: [
          { required: true, message: "投保人电话不能为空", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            transform(value) {
              return Number(value);
            },
            message: "请输入正确的电话号码",
          },
        ],
        holderBirth:[
          {
            required:true,
            type:'date',
            message:'请选择投保人出生日期',
            trigger:'change'
          }
        ],
        holderEmail: [
          {
            required:false,
            pattern:
              /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
            message: "请输入正确的邮箱",
          },
        ],
        holderIncome: [
          {
            required:false,
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              if(!value){
                return
              }
              return Number(value);
            },
            trigger:"blur"
          },
        ],
      },
      // 被保险人信息验证
      insuredFormValidate: {
        income: [
          {
            required:false,
            type: "number",
            message: "输入的类型为数字",
            transform(value) {
              if(!value){
                return
              }
              return Number(value);
            },
            trigger:"blur"
          },
        ],
        name: [{ required: true, message: "被保人姓名不能为空" }],
        idType: [
          {
            required: true,
            message: "请选择被保人证件类型",
            trigger: "change",
          },
        ],
        idNo: [{ required: true, message: "被保人证件号码不能为空" }],
        holderRelation: [
          { required: true, message: "请选择与投保人关系", trigger: "change" },
        ],
        birth:[
          {
            required:true,
            type:'date',
            message:'请选择被保人出生日期',
            trigger:'change'
          }
        ],
        mobile: [
          {
            required:false,
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            transform(value) {
              if(!value){
                return
              }
              return Number(value);
            },
            message: "请输入正确的电话号码",
            trigger:"blur"
          },
        ],
        email: [
          {
            pattern:
              /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
            message: "请输入正确的邮箱",
            trigger:"blur"
          },
        ],
      },
      // 受益人信息验证
      benefitValidate: {
        name: [{ required: true, message: "受益人姓名不能为空" }],
        insuranceRelation: [
          {
            required: true,
            message: "请选择与被保人的关系",
            trigger: "change",
          },
        ],
        idType: [
          {
            required: true,
            message: "请选择受益人证件类型",
            trigger: "change",
          },
        ],
        idNo: [
          {
            required: true,
            message: "受益人证件号码不能为空",
            trigger: "blur",
          },
        ],
        benefitScale: [
          { required: true, message: "受益比例不能为空", trigger: "blur" },
          { pattern: /^(\d|[1-9]\d|100)$/, message: "请输入0-100的整数" },
        ],
        benefitOrder: [
          { required: true, message: "受益顺序不能为空", trigger: "blur" },
          { pattern: /^(\d|[1-9]\d|100)$/, message: "请输入0-100的整数" },
        ],
      },
      // 被保人权益信息
      rightsValidate:{
        // name:[{required:true,message:'权益名称不能为空',trigger:'blur'}],
        // quota:[
        //   {required:true,message:'保障额度不能为空', trigger: "blur" },
        //   {
        //     type: "number",
        //     message: "输入的类型为数字",
        //     transform(value) {
        //       return Number(value);
        //     }
        //   }
        // ],
        // content:[
        //   {
        //     required:true,
        //     message:'保障内容不能为空',
        //     trigger:'blur'
        //   }
        // ]
      }
    };
  }
};
